(() => {
  if (customElements.get('mcase-dice-button')) return;

  class MCaseDice extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.cube = this.querySelector('.sm-mcase-dice__cube');
      this.shadow = this.querySelector('.sm-mcase-dice__shadow');
      this.host = this.closest('mcase-color-customizer');
      this.onRoll = () => this.roll();
      this.button.addEventListener('click', this.onRoll);
      this.colorObserver = new MutationObserver(() => this.syncColors());
      for (const letter of this.host.querySelectorAll('[data-title-part]')) {
        this.colorObserver.observe(letter, { attributes: true, attributeFilter: ['style'] });
      }
      this.syncColors();
    }

    syncColors() {
      for (const letter of this.host.querySelectorAll('[data-title-part]')) {
        const color = getComputedStyle(letter).color;
        this.style.setProperty(`--dice-${letter.dataset.titlePart}`, color);
        const tile = this.host.querySelector(`[data-letter-part="${letter.dataset.titlePart}"]`);
        if (tile) tile.style.backgroundColor = color;
      }
    }

    async roll() {
      if (this.rolling) return;
      this.rolling = true;
      this.button.setAttribute('aria-disabled', 'true');
      this.dataset.rolling = 'true';
      this.querySelector('[data-dice-status]').textContent = '';
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const frames = reducedMotion ? [{ opacity: 0.55 }, { opacity: 1 }] : [
        { transform: 'translateY(0) rotateX(-28deg) rotateY(-25deg) rotateZ(0deg)', offset: 0 },
        { transform: 'translateY(3px) rotateX(-34deg) rotateY(-18deg) rotateZ(4deg) scale(.94)', offset: .12 },
        { transform: 'translateY(-12px) rotateX(252deg) rotateY(395deg) rotateZ(140deg) scale(1.04)', offset: .44 },
        { transform: 'translateY(2px) rotateX(676deg) rotateY(1040deg) rotateZ(356deg)', offset: .84 },
        { transform: 'translateY(0) rotateX(692deg) rotateY(1055deg) rotateZ(360deg)', offset: 1 }
      ];
      const timing = { duration: reducedMotion ? 180 : 900, easing: 'cubic-bezier(.2,.65,.3,1)' };
      this.rotation = this.cube.animate(frames, timing);
      if (!reducedMotion) {
        this.shadowAnimation = this.shadow.animate([
          { transform: 'scale(1)', opacity: .22 },
          { transform: 'scale(.72)', opacity: .08, offset: .44 },
          { transform: 'scale(1.08)', opacity: .26, offset: .84 },
          { transform: 'scale(1)', opacity: .22 }
        ], timing);
      }
      try {
        await this.rotation.finished;
        if (this.isConnected && this.host.randomizeColors()) {
          this.syncColors();
          this.dataset.rollCount = String(Number(this.dataset.rollCount || 0) + 1);
        }
      } catch {
        // Removing the component cancels its active animation.
      } finally {
        this.rolling = false;
        this.button.removeAttribute('aria-disabled');
        delete this.dataset.rolling;
        this.rotation = null;
        this.shadowAnimation = null;
      }
    }

    disconnectedCallback() {
      this.colorObserver?.disconnect();
      this.button?.removeEventListener('click', this.onRoll);
      this.rotation?.cancel();
      this.shadowAnimation?.cancel();
    }
  }
  customElements.define('mcase-dice-button', MCaseDice);
})();
